const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the User Assignment User Facing component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {$translate} $translate injected to gain access to the global angular-translate functions
 */
app.directive('userAssignmentsView', ['Application', 'Authorization', 'Assignments', '$translate', function (Application, Authorization, Assignments, $translate) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../../templates/directives/user-assignments-view.html'),
    scope: {
      tab: '=?'
    },
    controller: ['$scope', '$filter', function ($scope, $filter) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.assignments = {};

      if ($scope.tab && $scope.tab === 'completed'){
        self.currentTab = 'completed';
      };

      var typeMap = {
        scorm: 'scorm',
        track: 'tracks',
        workshop: 'workshops',
        article: 'articles',
        video: 'videos',
        file: 'files',
        assessment: 'assessments',
        imported_content: 'imported-content',
        multi_session_workshop: 'multi-session-workshops',
        journey: 'journey',
      };

      self.goTo = function(link) {
        Application.navigation.goTo(link);
      };

      self.getDays = function(item) {
        var now = moment();
        var due = item.due_date && moment(item.due_date) || null;
        if (!due || due.valueOf() < now.valueOf()) {
          return null;
        }
        return Math.ceil(moment.duration(due.diff(now)).asDays());
      };

      self.trimHtml = function(text) {
        if (!text) {
          return '';
        }

        var div = document.createElement("div");
        div.innerHTML = text;
        var newText = div.textContent || div.innerText || "";

        var trimTo = 150;
        var addDots = false;
        if (newText.length > 150) {
          addDots = true;
        }

        newText = $filter('limitTo')(newText, trimTo);
        return addDots ? newText + '...' : newText;
      };


      self.initialize = function() {
        var assignmentsPromise = Assignments.find({
          assignee: self.user._id,
          fields: 'assignee,completed,completed_date,completed_content,assigner,article,media,track,quiz,scorm,imported_content,assessment,createdAt,assigned_content.content_id,assigned_content.content_type,due_date',
          sort: 'createdAt,-1',
          'article-populate': 'title,content,banner_image,archived',
          'media-populate': 'title,type,description,image,archived',
          'scorm-populate': 'title,description,banner_image,archived',
          'imported_content-populate': 'title,description,banner_image,archived',
          'assessment-populate': 'title,description,archived',
          'track-populate': 'name,description,banner_image,archived',
          'quiz-populate': 'title,description,banner_image,archived',
          'assigned_content.content_id-populate': 'title,name,description,banner_image,archived,type,image'
        }).$promise.then(function(assignments) {
          self.assignments = self.parseAndSet(assignments);
          self.loaded = true;
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', text: self.translations['dashboard.assignments.errorMessage'], duration: 5});
        });
      };

      $translate([
        'dashboard.assignments.errorMessage',
        'dashboard.assignments.deletedMessage',
        'dashboard.assignments.completedDate'
      ]).then(function(data){
        self.translations = data;

        self.parseAndSet = function(items) {
          var completed = [];
          var open = [];
          angular.forEach(items, function(assignment) {
            assignment.item = {
              title: null,
              link: '#/',
              type: null,
              due_in: self.getDays(assignment)
            };

            if (assignment.due_date && !assignment.completed_date) {
              if (new Date(assignment.due_date) < new Date()) {
                assignment.item.overdue = true;
              }
            }

            assignment.titles = [];
            var item = {};

            if (!assignment.assigned_content || !assignment.assigned_content.length) {
              return;
            }

            let validContentCount = 0;
            assignment.assigned_content.forEach(function(item) {
              var content = item.content_id;
              if (!content) {
                return;
              }
              if (content.archived) {
                return;
              }
              validContentCount += 1;
              let completedIDs = [];
              if (assignment.completed_content && assignment.completed_content.length) {
                completedIDs = assignment.completed_content.map(function(item) {return item.content_id});
              }
              assignment.titles.push({
                title: content.title || content.name || 'Untitled',
                type: content.type,
                link: '/view/' + typeMap[content.type] + '/' + content._id,
                description: content.description || content.content,
                image: content.banner_image || content.image,
                completed: completedIDs.indexOf(content._id) !== -1
              });
            });

            if (validContentCount > 0) {
              if (assignment.completed) {
                assignment.formattedDate = '--';
                if (assignment.completed_date) {
                  assignment.completed_date = new Date(assignment.completed_date);
                  var formatted = moment(assignment.completed_date).format('MMMM Do, YYYY');
                  $translate('dashboard.assignments.completedDate', { value: formatted }).then(function (data) {
                    assignment.formattedDate =  data;
                  });
                  assignment.formattedDateShort = moment(assignment.completed_date).format('MMM YYYY');
                }
                completed.push(assignment);
                return;
              }
              open.push(assignment);
            }
          });

          return {
            completed: completed,
            open: open
          };
        };

        self.initialize();
      });

    }],
    controllerAs: 'userAssignments'
  };
}]);
